/* global GoogleAnalyticsTracker $ TradeInValuations, XdMessaging*/
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import RatingDots from '../../lib/Components/RatingDots'
import styles from './FeaturedCarsSlider.module.sass'
import AuLogo from './images/logo'

class FeaturedCarsSlider extends PureComponent {
  state = {
    carsLoaded: !!this.props.cars,
    carsList: this.props.cars ? this.props.cars : [],
    loadImages: !this.props.lazyload,
    navigationOccurred: false,
  }

  _initCars() {
    if (this.state.carsList.length) {
      const { isForDealer } = this.props
      // We have hidden this from the markup outside react
      $('.featured-cars-slider-placeholder').hide()
      $('.featured_cars_list').show()

      const sliderGeneralOptions = {
        horizontal: 1,
        mouseDragging: 1,
        touchDragging: 1,
        speed: 300,
        moveBy: 254,
        easing: 'swing',
        releaseSwing: 1,
        startAt: 0,
        smart: true,
      }

      if ($('body').hasClass('mobile_layout')) {
        $(this.sliderFrame).sly({
          horizontal: 1,
          itemNav: 'basic',
          mouseDragging: 1,
          touchDragging: 1,
          speed: 300,
          releaseSwing: true,
        })
      } else if (this.props.usePageNavigation === 'true') {
        $(this.sliderFrame).sly(
          Object.assign(sliderGeneralOptions, {
            itemNav: 'basic',
            prevPage: $(this.prevRef),
            nextPage: $(this.nextRef),
          })
        )
      } else {
        $(this.sliderFrame).sly(
          Object.assign(sliderGeneralOptions, {
            itemNav: 'basic',
            startAt: 0,
            prevPage: $(this.prevRef),
            nextPage: $(this.nextRef),
          })
        )
      }

      $(this.sliderFrame).sly('one', 'move start', () =>
        this.setState({ navigationOccurred: true })
      )
      $(this.sliderFrame).sly('one', 'move start', function () {
        if (isForDealer) {
          typeof TradeInValuations === 'object' &&
            typeof TradeInValuations.trackEvent === 'function' &&
            TradeInValuations.trackEvent('Similar Cars Slider slided')
        } else {
          GoogleAnalyticsTracker.trackFeaturedCarsSliderEvent(
            `Featured Cars Slider slided`
          )
        }
      })
    } else if (this.state.carsLoaded) {
      $('.featured-cars-slider-placeholder').hide()
      $('.search-results-section__heading').hide()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.carsLoaded !== this.state.carsLoaded) {
      this._initCars()
    }
  }

  componentDidMount() {
    this._initCars()
    if (this.props.isForDealer) {
      typeof TradeInValuations === 'object' &&
        typeof TradeInValuations.trackEvent === 'function' &&
        TradeInValuations.trackEvent('Similar Cars Slider shown')
    }
  }

  async componentWillMount() {
    if (this.state.carsLoaded) {
      return
    }
    try {
      const res = await fetch(this.props.featuredCarsUrl)
      const cars = await res.json()

      await this._setStateWhenReady({ carsLoaded: true, carsList: cars })
    } catch (err) {
      console.warn(err)
    }
  }

  _setStateWhenReady(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    })
  }

  _renderCarImage = (car, i) => {
    // The default number of eager-loaded images in the featured carousel is set here
    const { lazyload, eagerloadCount = 4, willBeInView } = this.props
    const carImage =
      this.state.navigationOccurred ||
      (i < eagerloadCount && (!lazyload || willBeInView)) ? (
        // All images are lazy-loaded
        <img src={car.image_url} alt={car.headline} />
      ) : (
        <img
          src="data:image/gif;base64,R0lGODdhAQABAPAAAP///wAAACwAAAAAAQABAEACAkQBADs="
          alt="car image placeholder"
        />
      )

    return car.missing_image_fallback ? (
      <div className="featured-cars-no-image">{carImage}</div>
    ) : (
      carImage
    )
  }

  _renderFuelEconomy = (car) => {
    if (this.props.emissionInformation === null) {
      return
    }

    let parts = []

    if (car.energy_consumption) {
      parts.push(<span>{car.energy_consumption}</span>)
    }
    if (car.fuel_economy) {
      parts.push(<span className="consumption">{car.fuel_economy}</span>)
    }
    if (car.co2_emission) {
      parts.push(<span className="co2">{car.co2_emission}</span>)
    }
    if (!car.energy_consumption && !car.fuel_economy && !car.co2_emission) {
      parts.push(<span className="no-emission-info">-</span>)
    }

    return (
      <div
        className={`fuel-efficiency truncated ${this.props.country || 'en'}`}
      >
        {parts.length > 0 && parts.reduce((prev, curr) => [prev, ' | ', curr])}
      </div>
    )
  }

  _renderRatings = (car) => (
    <div className="au-valuation-rating one-line">
      <div className={`au-valuation-rating-label medium value${car.au_rating}`}>
        {car.rating_label}
      </div>
      <RatingDots rating={car.au_rating} />
    </div>
  )

  _renderSavings = (car) => {
    if (car.you_save_difference) {
      return (
        <div
          className={`featured-cars-savings rating-background-${car.au_rating}`}
        >
          <p>{car.price_difference_formatted}</p>
        </div>
      )
    } else {
      return (
        <div className="featured-cars-savings no-savings">
          <p>{car.estimated_price_formatted}</p>
        </div>
      )
    }
  }

  _trackClick = (car) => {
    // converting _ to spaces for backwards data compatibility in GA
    let sliderRef =
      this.props.sliderRef && this.props.sliderRef.split('_').join(' ')
    let isNewCar = car.is_new_car ? ' - new car' : ''
    if (this.props.isForDealer) {
      typeof TradeInValuations === 'object' &&
        typeof TradeInValuations.trackEvent === 'function' &&
        TradeInValuations.trackEvent('Similar Cars Slider click')
    } else {
      GoogleAnalyticsTracker.trackFeaturedCarsSliderEvent(
        `Featured Cars Slider click - ${sliderRef}`,
        car.link_target_blank ? `outgoing ${isNewCar}` : `inbound ${isNewCar}`,
        null,
        null,
        true
      )
    }
  }

  _trackSlide = () => {
    if (this.props.isForDealer) {
      typeof TradeInValuations === 'object' &&
        typeof TradeInValuations.trackEvent === 'function' &&
        TradeInValuations.trackEvent('Similar Cars Slider slided')
    } else {
      GoogleAnalyticsTracker.trackFeaturedCarsSliderEvent(
        `Featured Cars Slider slided`
      )
    }
  }

  _handleParentClick = (car) => {
    if (this.props.isForDealer) {
      return
    }
    this._trackClick(car)
  }

  _handleLinkClick = (e, redirectUrl, car) => {
    if (!this.props.isForDealer) {
      return
    }

    this._trackClick(car)
    // Make sure to open car in the new tab when clicked with cmd or ctrl
    // Else redirect to the car url in the current tab
    if (!(e.ctrlKey || e.metaKey)) {
      e.preventDefault()
      XdMessaging.sendMessage(window.parent, {
        action: 'SimilarCarsWidget.redirect',
        redirectUrl: redirectUrl,
      })
    }
  }

  _renderCarsList = (carsArray = []) => {
    carsArray = this.props.reverseList ? carsArray.reverse() : carsArray
    const { props } = this

    return carsArray.map((car, i) => (
      <div
        className="featured-cars-slider__car"
        key={car.id}
        onClick={() => this._handleParentClick(car)}
      >
        <a
          href={car.redirect_url}
          target={car.link_target_blank ? '_blank' : null}
          rel={car.link_target_blank ? 'noopener' : null}
          data-js-outgoing-link={car.link_target_blank ? true : null}
          data-featured={car.is_featured ? true : null}
          data-car-id={car.id}
          data-car-price={car.price}
          onClick={(e) => this._handleLinkClick(e, car.redirect_url, car)}
        >
          <div className="featured-cars-slider__image">
            {this._renderCarImage(car, i)}

            {!props.isForDealer && (
              <div className="featured-cars-slider__source-name-label">
                <span
                  className={`source-name truncated ${
                    car.link_target_blank ? 'external' : 'internal'
                  }`}
                >
                  {car.source_name}
                </span>
                &nbsp;
                {car.link_target_blank ? (
                  <i className="icon_inline moving-link-indicator" />
                ) : (
                  <span className="moving-link-indicator">›</span>
                )}
              </div>
            )}
          </div>

          <div className="featured-cars-slider__bottom">
            <div className="featured-cars-slider__headline truncated">
              {car.headline}
            </div>
            <div className="featured-cars-slider__price-container">
              <p> {car.formatted_price} </p>
            </div>
            <div className="featured-cars-slider__rating-container">
              {this._renderRatings(car)}
              {props.isForDealer ? (
                <div className={styles.ratingContainerLogo}>
                  <AuLogo />
                </div>
              ) : (
                this._renderSavings(car)
              )}
            </div>

            {car.distance_to_car ? (
              <div className="distance-and-location">
                <div className="distance-to-search-location visible">
                  {car.distance_to_car}
                </div>
              </div>
            ) : (
              <div className="distance-and-location">
                <div className="car-location truncated visible">
                  {car.location_complete}
                </div>
              </div>
            )}

            {this._renderFuelEconomy(car)}
          </div>
        </a>
      </div>
    ))
  }

  render() {
    const { state, props, _renderCarsList } = this

    if (!(state.carsList && state.carsList.length)) return null
    return (
      <div className={`${!props.isForDealer && 'featured-carousel-section'}`}>
        {props.sectionHeadline && (
          <h4 className={styles.sectionHeadline}>{props.sectionHeadline}</h4>
        )}
        <div className="featured-cars-slider">
          <div
            className="featured-cars-slider__frame frame"
            ref={(sliderFrame) => {
              this.sliderFrame = sliderFrame
            }}
          >
            <div
              className={` featured-cars-slider featured-cars-slider--simple slidee
              ${props.usePageNavigation === 'true' ? 'page-navigation' : ''}`}
            >
              {state.carsLoaded
                ? _renderCarsList(state.carsList)
                : 'Loading cars'}
            </div>
          </div>
          {state.carsList && state.carsList.length > 4 ? (
            <div className="featured-cars-slider__controls">
              <div
                className="featured-cars-slider__prev"
                onClick={() => this._trackSlide()}
                ref={(prevRef) => {
                  this.prevRef = prevRef
                }}
              />
              <div
                className="featured-cars-slider__next"
                onClick={() => this._trackSlide()}
                ref={(nextRef) => {
                  this.nextRef = nextRef
                }}
              />
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

FeaturedCarsSlider.propTypes = {
  featuredCarsUrl: PropTypes.string,
  country: PropTypes.string,
  emissionInformation: PropTypes.string,
  reverseList: PropTypes.string,
  sliderRef: PropTypes.string,
  cars: PropTypes.array,
  sectionHeadline: PropTypes.string,
  usePageNavigation: PropTypes.string,
  lazyload: PropTypes.bool,
  eagerloadCount: PropTypes.number,
  willBeInView: PropTypes.bool,
  version: PropTypes.string,
  isForDealer: PropTypes.bool,
}

FeaturedCarsSlider.defaultProps = {
  isForDealer: false,
}

export default FeaturedCarsSlider
